import { render, staticRenderFns } from "./PMStructure.vue?vue&type=template&id=6165eb28&"
import script from "./PMStructure.vue?vue&type=script&lang=ts&"
export * from "./PMStructure.vue?vue&type=script&lang=ts&"
import style0 from "./PMStructure.vue?vue&type=style&index=0&id=6165eb28&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports